import { currencyFormatter } from '@services/currency-formatter';

import { useLocale } from './useLocale';

export const useCurrencyFormatter = () => {
  const { locale } = useLocale();

  return { currencyFormatter: currencyFormatter(locale) };
};
